import React from 'react';
import { StyleSheet, Text, View, Image } from 'react-native';
import loading_gif from '../assets/loader_gif.gif';
import {
    useFonts,
    Roboto_100Thin,
    Roboto_100Thin_Italic,
    Roboto_300Light,
    Roboto_300Light_Italic,
    Roboto_400Regular,
    Roboto_400Regular_Italic,
    Roboto_500Medium,
    Roboto_500Medium_Italic,
    Roboto_700Bold,
    Roboto_700Bold_Italic,
    Roboto_900Black,
    Roboto_900Black_Italic,
} from '@expo-google-fonts/roboto';

export default function Loader() {
    let [fontsLoaded] = useFonts({
        Roboto_100Thin,
        Roboto_100Thin_Italic,
        Roboto_300Light,
        Roboto_300Light_Italic,
        Roboto_400Regular,
        Roboto_400Regular_Italic,
        Roboto_500Medium,
        Roboto_500Medium_Italic,
        Roboto_700Bold,
        Roboto_700Bold_Italic,
        Roboto_900Black,
        Roboto_900Black_Italic,
    });
    return (
        <View style = {styles.main_wraper}>
            <Text style = {{color: '#000', fontSize: 30, fontFamily: "Roboto_400Regular"}}>Your weather data is loading...</Text>
            <Image source = {loading_gif} style = {{width: 800, height: 284}}/>
            <Text style={{ color: '#000', fontFamily: 'Roboto_700Bold', }}>Made with ❤️️ by <Text style={{ textDecorationLine: 'underline' }} onPress={() => window.open('https://www.facebook.com/arefin.anwar.71/', "_blank")}>Arefin Anwar</Text></Text>
        </View>
    )
}

const styles = StyleSheet.create({
    main_wraper:{
        width: '100%',
        height: '100%',
        backgroundColor: 'white',
        alignItems: 'center',
        justifyContent: 'center',
    }
})
